<template>
  <div class="grid grid-cols-4 md:grid-cols-5 gap-4 justify-items-center">
    <!-- Loop through images -->
    <div 
      v-for="(image, index) in images" 
      :key="image.id || image.src || index" 
      @click="selectImage(index)" 
      class="relative flex justify-center items-center cursor-pointer hover:opacity-80"
    >
      <!-- Container for the image -->
      <div
        class="w-full overflow-hidden flex justify-center items-center"
        :class="{ 'border-4 border-[#08697b]': selectedImageIndex === index }"
      >
        <img 
          :src="image.src" 
          class="object-cover w-full h-full"
        />
      </div>
      <span v-if="image.isNew" class="new-pill">New</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviewGrid",
  props: { 
    images: { type: Array, default: () => [] },
    selectedImages: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedImageIndex: null 
    }
  },
  methods: {
    selectImage(index) {
      this.selectedImageIndex = index;
      this.$emit('select-image', index);
    }
  }
};
</script>

<style>
.new-pill {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #08697b;
  color: #fff;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 0 6px 16px rgba(8, 105, 123, 0.25);
}
.selected {
  border: 5px solid #08697b;
}
.selected img {
  padding: 0;
}
</style>
